import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class StyleManager {
  private readonly DARK_THEME_KEY = 'darkTheme';

  isDark = false;

  constructor() {
    this.isDark = this.isDarkModeEnabled();
    this.updateTheme();
  }

  toggleDarkTheme() {
    this.isDark = !this.isDark;
    this.updateTheme();
    this.saveThemePreference();
  }

  private updateTheme() {
    if (this.isDark) {
      const href = 'dark-theme.css';
      getLinkElementForKey('dark-theme').setAttribute('href', href);
      document.body.classList.add('dark-theme');
    } else {
      this.removeStyle('dark-theme');
      document.body.classList.remove('dark-theme');
    }
  }

  private saveThemePreference() {
    localStorage.setItem(this.DARK_THEME_KEY, this.isDark ? 'true' : 'false');
  }

  private isDarkModeEnabled() {
    const savedTheme = localStorage.getItem(this.DARK_THEME_KEY);
    return savedTheme === 'true';
  }

  private removeStyle(key: string) {
    const existingLinkElement = getExistingLinkElementByKey(key);
    if (existingLinkElement) {
      document.head.removeChild(existingLinkElement);
    }
  }
}

function getLinkElementForKey(key: string) {
  return getExistingLinkElementByKey(key) || createLinkElementWithKey(key);
}

function getExistingLinkElementByKey(key: string) {
  return document.head.querySelector(
    `link[rel="stylesheet"].${getClassNameForKey(key)}`
  );
}

function createLinkElementWithKey(key: string) {
  const linkEl = document.createElement('link');
  linkEl.setAttribute('rel', 'stylesheet');
  linkEl.classList.add(getClassNameForKey(key));
  document.head.appendChild(linkEl);
  return linkEl;
}

function getClassNameForKey(key: string) {
  return `style-manager-${key}`;
}